import styled from 'styled-components';

const PageHeader = styled.div`
  text-align: center;
  max-width: 47rem;
  padding: 2rem 2rem 0 2rem;
  ${({ noMargin }) => !noMargin && 'margin: 3rem auto 0' }
`;

export { PageHeader };